const validWording = "Please enter valid "
const pleaseEnterWording = "Please enter "

//PolicyInformation
export const policyNumber =
  pleaseEnterWording + "8 character policy number starting with ‘P’"
export const policyHolderName = validWording + "policyholder's full name"
export const claimantName = validWording + "claimant full name"
export const claimantNricNumber = validWording + "claimant NRIC/FIN number"
export const claimantEmail = validWording + "email ID"
export const claimantMobile = validWording + "mobile number"

//Common
export const claimAmount = validWording + "Amount Claimed"
export const childName = validWording + "Name of Child"
export const childBirthDate = validWording + "Date of Birth"
export const childNRIC = validWording + "Child NRIC"
export const futureTimeErrorMsg = "Future time is not allowed"
export const deathDateEarlierThanAccident =
  "Date of Death cannot be earlier than Date of Accident"
export const birthDate = validWording + "Date of Birth"

//Death Form
export const occurrenceDate = validWording + "Date of Accident"
export const occurrenceTime = validWording + "Time of Accident"
export const deathDate = validWording + "Date of Death"
export const deathTime = validWording + "Time of Death"
export const deathNature = validWording + "Nature of Death"
export const deathReason = validWording + "Offical Cause of Death"
export const otherPartyName =
  validWording + "Name of other party/insurance company"
export const otherPartyPolicyNumber =
  validWording +
  "Policy number/reference number of other party/insurance company"
export const otherPartyDescription =
  validWording +
  "Description of claim made against other party/insurance company"
export const deathVictimName = validWording + "Name of Deceased"
export const deathVictimNric = validWording + "Deceased NRIC"

//UI Disablement
export const DisablementAccidentDate = validWording + "Date of Accident"
export const DisablementAccidentTime = validWording + "Time of Accident"
export const DisablementAccidentNature = validWording + "Nature of Accident"
export const DisablementNature = validWording + "Nature of Disablement"
export const DisablementDescription =
  validWording + "Description of Disablement"
export const DisablementAccidentDate52WeeksErrorMsg =
  "Date of Accident must be at least 52 weeks earlier"
export const disabledVictimName = validWording + "Name of Disabled"
export const disabledVictimNric = validWording + "Disabled NRIC"

//UI Medical
export const MedicalAccidentDate = validWording + "Date of Accident"
export const MedicalAccidentTime = validWording + "Time of Accident"
export const MedicalAccidentDescription =
  validWording + "Description of Accident"
export const MedicalAccidentLocation = validWording + "Location of Accident"
export const MedicalInjuryNature = validWording + "Nature of Injury"

//UI Hospital Allowance
export const HospitalAccidentDate = validWording + "Date of Accident"
export const HospitalAccidentLocation = validWording + "Location of Accident"
export const HospitalAccidentNature = validWording + "Nature of Accident"
export const HospitalAdmissionDate = validWording + "Admission Date"
export const HospitalAdmissionTime = validWording + "Admission Time"
export const HospitalDischargeDate = validWording + "Discharge Date"
export const HospitalDischargeTime = validWording + "Discharge Time"
export const HospitalAdmissionEarlierThanAccident =
  "Admission Date cannot be earlier than Date of Accident"
export const HospitalDischargeEarlierThanAccident =
  "Discharge Date cannot be earlier than Date of Accident"
export const HospitalDischargeEarlierThanAdmission =
  "Discharge Date cannot be earlier than Admission Date"

//UI Bicycle
export const BicycleClaimNature = validWording + "Nature of Claim"
export const BicyclePurchaseValue = validWording + "Bicycle Purchase Value"
export const BicycleMake = validWording + "Bicycle Make"
export const BicycleModel = validWording + "Bicycle Model"
export const BicyclePurchaseDate = validWording + "Date of Purchase"
export const BicycleSerialNumber = validWording + "Bicycle Serial Number"
export const BicycleDamageDate = validWording + "Date damage was discovered"
export const BicycleDamageTime = validWording + "Time damage was discovered"
export const BicycleDamageCause = validWording + "Cause of Damage"
export const BicycleDamagePart = validWording + "Damaged bicycle part"
export const BicycleLossDate = validWording + "Date of Loss"
export const BicycleLossTime = validWording + "Time of Loss"
export const BicycleLossLocation = validWording + "Location of Loss"
export const BicycleDamageEarlierThanPurchase =
  "Date damage cannot be earlier than Date of Purchase"
export const BicycleLossEarlierThanPurchase =
  "Date of Loss cannot be earlier than Date of Purchase"

//UI Other Benefits
export const OtherBenefitsAccidentDate = validWording + "Date of Accident"
export const OtherBenefitsAccidentTime = validWording + "Time of Accident"
export const OtherBenefitsAccidentLocation =
  validWording + "Location of Accident"
export const OtherBenefitsAccidentDescription =
  validWording + "Description of Accident"
